<template>
    <div class="front-form">
        <div class="front-form__wrap">
            <v-card class="elevation-12 front-form__block">
                <v-toolbar dark color="primary login__logotype">
                    <v-toolbar-title>{{ $t('msg.newPassword') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <v-text-field
                                prepend-icon="mdi-lock"
                                name="password"
                                :label="$t('msg.password')"
                                type="password"
                                v-model="model.password"
                                v-validate="'required|min:6|max:255'"
                                :error-messages="errors.collect('password')"
                                @keyup.enter="onSubmit()"
                                ref="first_password"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                        ></v-text-field>
                        <v-text-field
                                prepend-icon="mdi-lock"
                                name="repeat_password"
                                :label="$t('msg.repeatPassword')"
                                type="password"
                                v-model="model.repeat_password"
                                v-validate="'required|repeat_password:first_password'"
                                :error-messages="errors.collect('repeat_password')"
                                @keyup.enter="onSubmit()"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="onSubmit"
                            :disabled="loading"
                            :loading="loading"
                            small
                            class="mr-2 mb-3"
                            elevation="0"
                    >{{ $t('msg.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div class="front-form__links">
            <router-link
                    :to="{name: 'login'}"
            >{{ $t('msg.login') }}</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                loading: false,
                model: {
                    id: null,
                    password: null,
                    key_rec_pass: null
                }
            }
        },
        methods: {
            onSubmit () {
                this.$validator.validateAll()
                    .then(res => {
                        if (res) {
                            this.loading = true;
                            this.$store.dispatch('recoveryPasswordConfirmEmail', {
                                data: this.model,
                                formErrors: this.$validator.errors
                            })
                                .then(() => {
                                    this.$store.commit('setSnackBarInfo', this.$t('msg.passwordSaved'));
                                    this.$router.push({name: 'login'});
                                })
                                .finally(() => this.loading = false);
                        } else {
                            this.scrollToError(this.$validator.errors);
                        }
                    });
            }
        },
        created() {
            this.model.id = parseInt(this.$route.query.id);
            this.model.key_rec_pass = this.$route.query.key;
        }
    }
</script>

<style lang="scss">
    .login__logotype {
        .v-toolbar__content {
            display: flex;
            justify-content: center;
        }
    }
</style>
